import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { fromPrizeTypeToHumanReadableText } from 'widgets/prize/lib';
import { MoreInfo, StyledCard } from 'shared/ui';
import { toFirstLetterUppercase } from 'shared/utils';
import { useGetPrizeIdQuery } from 'entities/prize/api/getPrizeList';
import { fromDateToHumanReadableText } from 'shared/helpers/fromDateToHumanReadableText';
import { CloudDownload } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { BASE_URL } from 'shared/conf/constants';
import { downloadTableCodesFile } from 'entities/prize/api/downloadTableCodesFile';

export const PrizesDetailInfo = () => {
  const { id } = useParams();
  const [isLoadingDownloadTable, setIsLoadingDownloadTable] = useState(false);

  const { data: prize } = useGetPrizeIdQuery({ id });

  const handleTableCodesDownload = () => {
    setIsLoadingDownloadTable(true);
    const url = `${BASE_URL}/shop${prize?.download_prize_array_url}`;

    downloadTableCodesFile({ url, setIsLoadingDownloadTable });
  };

  return (
    <Box
      component={StyledCard}
      sx={{
        marginBottom: '24px',
      }}
    >
      <Typography>Данные о призе</Typography>
      <Box
        style={{
          display: 'flex',
          marginTop: '12px',
        }}
      >
        <div
          className="column"
          style={{ width: '700px' }}
        >
          <MoreInfo>
            <div className="title">Тип приза</div>
            <div className="content">
              {prize?.category ? toFirstLetterUppercase(fromPrizeTypeToHumanReadableText(prize?.category)) : '---'}
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Название приза</div>
            <div className="content">{prize?.name?.ru ?? '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Описание приза</div>
            <div className="content">{prize?.description?.ru ?? '---'}</div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Основное фото</div>
            <div className="content">
              <img
                src={prize?.image}
                style={{ maxWidth: '100px', maxHeight: '100px' }}
                alt="Основное фото"
              />
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Иконка списка</div>
            <div className="content">
              <img
                src={prize?.icon}
                style={{ maxWidth: '100px', maxHeight: '100px' }}
                alt="Иконка списка"
              />
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Дата начала</div>
            <div className="content">
              {prize && prize.min_start_date ? fromDateToHumanReadableText(`${prize.min_start_date}`) : '---'}
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Дата окончания</div>
            <div className="content">
              {prize && prize.max_end_date ? fromDateToHumanReadableText(`${prize.max_end_date}`) : '---'}
            </div>
          </MoreInfo>
          <MoreInfo>
            <div className="title">Таблица кодов</div>
            <div
              className="content"
              style={{ marginTop: '15px' }}
            >
              <LoadingButton
                startIcon={<CloudDownload />}
                loading={isLoadingDownloadTable}
                disabled={isLoadingDownloadTable}
                onClick={handleTableCodesDownload}
                variant="outlined"
              >
                Скачать
              </LoadingButton>
            </div>
          </MoreInfo>
        </div>
      </Box>
    </Box>
  );
};
